module.exports = __webpack_public_path__ + "static/cube6-3cc02705ab6cb32d8d526ed7f18cc3ab.svg";